import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../../../services/api";
import getImageUrl from "../../../utils/imageUrl"; 
import "./RecommendedProviders.css";

const RecommendedProviders = () => {
  const { category } = useParams();
  const navigate = useNavigate();

  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProviders();
  }, [category]);

  const fetchProviders = async () => {
    try {
      setLoading(true);

     const res = await API.get(
  `/customer/recommended/${category}`
);

      setProviders(res.data.providers || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <h2>Loading...</h2>;
  }

  return (
    <div className="recommended-providers-page">

      <div className="recommended-header">
        <button onClick={() => navigate(-1)}>
          ← Back
        </button>

        <h2>{category}</h2>
      </div>

      <div className="providers-grid">
        {providers.map((provider) => (
         <div
  key={provider.providerId}
  className="provider-card"
  onClick={() =>
    navigate(`/provider/${provider.providerId}`)
  }
>
  <div className="provider-image">
   <img
  src={
    getImageUrl(provider.image) ||
    "/images/food-placeholder.png"
  }
  alt={provider.businessName || "Provider"}
  onError={(e) => {
    e.currentTarget.src =
      "/images/food-placeholder.png";
  }}
/>

    <button
      className="favorite-btn"
      onClick={(e) => {
        e.stopPropagation();
        // Favorite logic later
      }}
    >
      ♡
    </button>
  </div>

  <div className="provider-content">

    <div className="provider-top">

      <h3>{provider.businessName}</h3>

      <span className={`status ${provider.businessStatus === "Open" ? "open" : "closed"}`}>
        {provider.businessStatus}
      </span>

    </div>

    <div className="provider-info">

      <span>{provider.providerType}</span>

      <span>⭐ {provider.rating}</span>

    </div>

    <div className="provider-footer">

      <span>{provider.foodCount} Items</span>

    </div>

  </div>
</div>
        ))}
      </div>
    </div>
  );
};

export default RecommendedProviders;